import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router";
import { PrivateRoute, PublicRoute } from "./Routes/routes";
// import {PrivateRoute} from './Routes/privateRoutes';
// import {PublicRoute} from './Routes/publicRoutes';
import Home from "./pages/publicPages/Home";
import Login from "./pages/publicPages/Login";
import Dashboard from "./pages/privatePages/Dashboard";
import { privatePages, publicPages } from "./Routes/routeData";
import "./App.css";
import "./ckeditor5-content.css";
import ReactGA from "react-ga4";
// import "webxr-polyfill"; 
// import 'bootstrap/dist/css/bootstrap.css';

// 🔍 This component handles GA initialization and pageview tracking
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4 once
    ReactGA.initialize("G-DM1EBC3TL5"); // 🔁  GA4 Measurement ID
  }, []);

  useEffect(() => {
    // Send pageview on every route change
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

export default function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <AnalyticsTracker /> {/* 📈 Google Analytics tracking */}
      <Routes>
        {/* Public Routes */}
        {
          publicPages.map((route,idx) => {
            return (
              <Route
              key={idx}
              path={route.path}
              element={
                <PublicRoute>
                  {route.component}
                </PublicRoute>
              }
            />
            )
          })
        }
        {/* <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        /> */}

        {/* Private Routes */}
        {
          privatePages.map((route,idx) => {
            return (
              <Route
              key={idx}
              path={route.path}
              element={
                <PrivateRoute>
                  {route.component}
                </PrivateRoute>
              }
            />
            )
          })
        }
       
        {/* General Routes */}
        {/* <Route path="/" element={<Home />} /> */}
      </Routes>
    </BrowserRouter>
    </HelmetProvider>
  );
}
